<template>
  <zl-dialog class="zl-saas voucher-common-dialog" title="查看凭证" ref="dialog" width="1200px" :close-on-click-modal="false">
    <div class="common-btns" v-if="!isPreview">
      <!-- <el-button icon="el-icon-s-check" plain type="primary">签章</el-button> -->
      <el-button icon="iconfont icon-xiazai" type="primary" @click="downloadPayOrder">下载</el-button>
    </div>
    <div class="common-content">
      <p class="common-title">订单付款凭证</p>
      <div class="common-content__item">
        <el-row>
          <el-col :span="24">
            <p class="common-content__title">基本信息</p>
          </el-col>
          <el-row>
            <el-col :span="24">
              <el-row class="common-content__flex">
                <el-col class="common-content__left common-col__style el-col-15">
                  订单名称
                </el-col>
                <el-col class="common-content__right common-col__style common-border-right el-col-35">
                  {{detailInfo.orderName || '无'}}
                </el-col>
                <el-col class="common-content__left common-col__style el-col-15" >
                  订单编号
                </el-col>
                <el-col class="common-content__right common-col__style el-col-35">
                  {{detailInfo.orderCode || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  采购单位
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style common-border-right">
                  {{detailInfo.purchaseName || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  供应商
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style">
                  {{detailInfo.supplierName || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  下单时间
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style common-border-right">
                  {{detailInfo.releaseTime && dayjs(detailInfo.releaseTime).format('YYYY-MM-DD HH:mm:ss') || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  接单时间
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style">
                  {{detailInfo.confirmTime && dayjs(detailInfo.confirmTime).format('YYYY-MM-DD HH:mm:ss') || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" v-if="detailInfo.projectName">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  关联履约项目名称
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style common-border-right">
                  {{detailInfo.projectName || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" v-if="detailInfo.projectCode">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  关联履约项目编号
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style">
                  {{detailInfo.projectCode || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col >
              <el-row class="common-content__flex">
                <template v-if="detailInfo.inquireName">
                  <el-col class="common-content__left common-col__style el-col-15">
                    关联询单名称
                  </el-col>
                  <el-col class="common-content__right common-col__style common-border-right el-col-35">
                    {{detailInfo.inquireName || '无'}}
                  </el-col>
                </template>
                <template v-if="detailInfo.inquireCode">
                  <el-col class="common-content__left common-col__style el-col-15">
                    关联询单编号
                  </el-col>
                  <el-col class="common-content__right common-col__style el-col-35">
                    {{detailInfo.inquireCode || '无'}}
                  </el-col>
                </template>
              </el-row>
            </el-col>
            <!-- <el-col :span="12" v-if="detailInfo.inquireCode">
              <el-row>

              </el-row>
            </el-col> -->
            <el-col :span="12" v-if="detailInfo.contractName">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  关联合同名称
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style common-border-right">
                  {{detailInfo.contractName || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" v-if="detailInfo.contractCode">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  关联合同编号
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style">
                  {{detailInfo.contractCode || '无'}}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
        <el-row>
          <el-col :span="24">
            <p class="common-content__title">订单执行情况</p>
          </el-col>
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="4" class="common-content__left common-col__style">
                  订单预算总金额（元）
                </el-col>
                <el-col :span="20" class="common-content__right common-col__style">
                  {{_util.formatMoney(detailInfo.budgetAmount)}} {{detailInfo.currencyCH}}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
        <el-row>
          <el-col :span="24">
            <p class="common-content__title">子订单信息</p>
          </el-col>
          <el-row>
            <el-col :span="24">
              <div class="common-table-box">
                <template v-if="detailInfo && detailInfo.subOrderList">
                  <el-table :data="detailInfo.subOrderList" :header-cell-style="{background: '#F5F6FA !important', borderColor: '#7E8EA5'}" show-summary  :summary-method="getSummaries">
                    <el-table-column
                      show-overflow-tooltip
                      prop="subOrderCode"
                      label="子订单编号">
                    </el-table-column>
                    <el-table-column
                      prop="deliverAmount"
                      label="供应商发货金额(元)">
                      <template slot-scope="scope">
                        {{scope.row.deliverAmount && _util.formatMoney(scope.row.deliverAmount)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="checkAmount"
                      label="验收金额(元)">
                      <template slot-scope="scope">
                        {{scope.row.checkAmount && _util.formatMoney(scope.row.checkAmount)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="accountMoney"
                      label="最终结算金额(元)">
                      <template slot-scope="scope">
                        {{scope.row.accountMoney && _util.formatMoney(scope.row.accountMoney)}}
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <template v-else>
                  供应商未发货
                </template>
              </div>
            </el-col>
          </el-row>
        </el-row>
        <el-row>
          <el-col :span="24">
            <p class="common-content__title">订单申请付款记录</p>
          </el-col>
          <el-row>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  本次付款申请人
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style common-border-right">
                  {{detailInfo && detailInfo.paymentDTO.creatorName || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="common-content__left common-col__style">
                  本次申请付款金额(元)
                </el-col>
                <el-col :span="16" class="common-content__right common-col__style">
                  {{ detailInfo && _util.formatMoney(detailInfo.paymentDTO.applyMoney)}} {{detailInfo && detailInfo.currencyCH}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="4" class="common-content__left common-col__style">
                  操作时间
                </el-col>
                <el-col :span="20" class="common-content__right common-col__style">
                  {{detailInfo && detailInfo.paymentDTO.createTime && dayjs(detailInfo.paymentDTO.createTime).format('YYYY-MM-DD HH:mm:ss') || '无'}}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <div class="common-table-box">
                <el-table :data="detailInfo.paymentDTOList" :header-cell-style="{background: '#F5F6FA !important', borderColor: '#7E8EA5'}">
                  <el-table-column
                    show-overflow-tooltip
                    prop="creatorName"
                    label="历史付款申请人">
                  </el-table-column>
                  <el-table-column
                    prop="applyMoney"
                    label="申请金额(元)">
                    <template slot-scope="scope">
                      {{_util.formatMoney(scope.row.applyMoney)}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="操作时间">
                    <template slot-scope="scope">
                      {{scope.row.createTime && dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </div>
      <div class="receipt-box">
        回执生成时间：{{detailInfo.createTime && dayjs(detailInfo.createTime).format('YYYY-MM-DD HH:mm:ss')}}
      </div>
    </div>
  </zl-dialog>
</template>
<script>
import store from '@/store'
import dayjs from 'dayjs'
import config from '@/config/config'
export default {
  data() {
    return {
      dayjs,
      detailInfo: '',
      isPreview: false, // 是否是预览付款凭证
      orderId: '', // 订单id
      paymentId: '' // 付款id
    }
  },
  methods: {
    async open(args) {
      this.orderId = args.orderId
      this.paymentId = args.paymentId
      this.isPreview = !!args.isPreview
      console.log('isPreview', this.isPreview)
      await this.previewPayMent(args)
      return this.$refs.dialog.open()
    },
    previewPayMent(args) {
      store.dispatch('previewPaymentEvidenceOrder', args)
        .then(res => {
          this.detailInfo = {
            ...res
          }
        })
    },
    // 下载付款凭证
    async downloadPayOrder() {
      let fileId
      await store.dispatch('downloadOrderPayCert', {
        paymentId: this.paymentId
      })
        .then(res => {
          fileId = res
        })
      const result = await this._util.getFileToken(2, 1, fileId)
      window.open(`${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${fileId}&token=${result}`)
    },
    // 合计行
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计' + `  (${this.detailInfo.currencyCH})`
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = ''
        }
        sums[index] = this._util.formatMoney(sums[index])
      })
      return sums
    },
    cancel() {
      this.$refs.dialog.cancel()
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/voucher.scss';
</style>
